/**
 * Created by Abner Sui on 06/11/2019.
 * Description:
 *
 * ------ maintenance history ------
 */


import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { EmailDigest } from '../../tamalelibs/models/emaildigest.model';
import { EmailDigestService } from '../../services/email-digest.service';

@Component({
    selector: 'email-digest-scheduler-info',
    templateUrl: './email-digest-scheduler-info.component.html',
    styleUrls: ['./email-digest-scheduler-info.component.scss']
})
export class EmailDigestSchedulerInfoComponent implements ICellRendererAngularComp, OnInit {

    item: EmailDigest;
    showTimezone = false;

    constructor(
        private _emailDigestService: EmailDigestService,
    ) { }

    ngOnInit() {
    }

    agInit(params: any): void {
        this.item = this._emailDigestService.addConfigurationTimezone(params.data);
        if (this.item && this.item.scheduler && this.item.scheduler.configuration) {
            // only show time if they are not in the same timezone, like '-07:00'
            this.showTimezone = !this.item.scheduler.configuration.includes(this._emailDigestService.getLocalHourOffset());
        }
    }

    refresh(params: any): boolean {
        return true;
    }

}
